<template>
  <div id="app">
    <Index></Index>
  </div>
</template>

<script>
import Index from '@/components/Index.vue'
 export default {
  name:'App',
  components:{Index},
  mounted () {
    const computed = function () {
      // 设计稿宽度：1920
      const desW = 1920
      const devW = document.documentElement.clientWidth
      if (devW > 1280) {
        document.documentElement.style.fontSize = devW / desW * 75 + 'px'
        // 这里的75是使用postcss-px2rem插件时，配置的remUnit的参数值
      } else {
        document.documentElement.style.fontSize = 50 + 'px'
      }
    }
    computed()
    window.addEventListener('resize', computed, false)
  }


 }
</script>

<style lang="scss">
// #app {
//   font-size: 14Px  !important;
//   min-width: 1280Px;
// }
</style>
